import React from 'react';

import { Heading, ListingCard } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const SectionSimilarListings = props => {
  const { similarListings, fetchsimilarListingsInProgress, fetchsimilarListingsError } = props;

  if (fetchsimilarListingsInProgress || fetchsimilarListingsError || similarListings.length === 0) {
    return null;
  }

  return (
    <div className={css.sectionSimilarListings}>
      <Heading as="h2" rootClassName={css.sectionTitle}>
        <FormattedMessage id="ListingPage.similarListings" />
      </Heading>
      <div className={css.similarListings}>
        {similarListings.map(l => {
          return <ListingCard key={l.id.uuid} listing={l} />;
        })}
      </div>
    </div>
  );
};

export default SectionSimilarListings;
